{
  "manager": {
    "globalSearchResults": {
      "searching": "Searching...",
      "unavailable": "Search is temporarily unavailable.",
      "noResults": "No results found for \"{query}\""
    },
    "globalSearch": {
      "searchPlaceholder": "Search users, programs, volunteer opportunities, calendars",
      "goTo": "Go to",
      "takeAction": "Take action",
      "useAgent": "Use agent",
      "results": "Results",
      "confirmRunAction": "Run \"{title}\"?",
      "actionUnavailable": "This action is unavailable right now.",
      "sessionExpired": "Your session has expired. Please log in again.",
      "searchUnavailable": "Search is temporarily unavailable."
    },
    "globalSearchResultItem": {
      "actions": "Actions",
      "agents": "Agents",
      "pages": "Pages",
      "goTo": "Go to",
      "run": "Run",
      "ask": "Ask",
      "open": "Open"
    }
  }
}
